import * as React from "react";
import ConnectedFormControl from "../../FormControl/FormControl/FormControl.js";
import { isText } from "../../Util/Util/validations.js";
const Region = ({
  label,
  errorMessage,
  validations = [isText],
  ...rest
}) => /* @__PURE__ */ React.createElement(
  ConnectedFormControl,
  {
    ...ConnectedFormControl.defaultProps,
    id: "region",
    "data-t": "region",
    label,
    errorMessage,
    validations,
    ...rest
  }
);
export {
  Region as default
};
//# sourceMappingURL=Region.js.map
